// extracted by mini-css-extract-plugin
module.exports = {"root":"IconCard_root__0BbjC","imageBox":"IconCard_imageBox__w7VcZ","detailDescription":"IconCard_detailDescription__gCkY_","rotation":"IconCard_rotation__Stw6p"};